import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';
import { useLanguage } from '../../../contexts/LanguageContext';

const AuthHeader = ({ activeTab }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const content = {
    login: {
      title: t('welcomeBack'),
      subtitle: t('signInToContinue')
    },
    signup: {
      title: t('createYourAccount'),
      subtitle: t('joinListingLens')
    }
  };

  const currentContent = content?.[activeTab];

  return (
    <div className="text-center mb-6 md:mb-8">
      <button
        onClick={() => navigate('/')}
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors mb-4 group"
      >
        <Icon name="ArrowLeft" size={16} className="group-hover:-translate-x-1 transition-transform" />
        {t('goBack')}
      </button>

      <div className="flex justify-center mb-4 md:mb-6">
        <AppImage
          src="/assets/images/logo_LL-1772022913346.jpeg"
          alt="ListingLens Logo"
          className="h-14 w-auto cursor-pointer"
          onClick={() => navigate('/')}
        />
      </div>
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2 md:mb-3 font-heading">
        {currentContent?.title}
      </h1>
      <p className="text-sm md:text-base text-muted-foreground max-w-md mx-auto font-body">
        {currentContent?.subtitle}
      </p>
    </div>
  );
};

export default AuthHeader;